import {UI} from "../../../stem-core/src/ui/UIBase.js";

import {Messages} from "../../Messages.js";
import {Link} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {Flow} from "../initializeFlows.js";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {redirectToMerchantHomepage} from "../../widget/misc/WidgetUtils.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {MessageElement} from "../../widget/ui/MessageElement.jsx";
import {ThankYouPanelStyle} from "./ThankYouPanel.jsx";


@registerStyle(ThankYouPanelStyle)
export class DonationCanceledPanel extends UI.Element {
    render() {
        const {styleSheet} = this;
        const donation = Flow.donation.previouslyCanceledDonation;
        const publicationName = iFrameMerchantService.getMerchant().name;

        return [
            <div className={styleSheet.title}>{Messages.donatePageDonationCanceledTitle}</div>,
            <MessageElement className={styleSheet.text}
                            message={Messages.donatePageDonationCanceledText1(donation.formatPrice())}/>,
            <div className={styleSheet.text}>{Messages.donatePageDonationCanceledText2}</div>,
            <MerchantButton onClick={redirectToMerchantHomepage} className={styleSheet.button}>
                {Messages.returnToHomepage(publicationName)}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.donatePageDonationCanceledMakeDonation} className={styleSheet.link}
                      onClick={() => this.options.changeURL(DONATE_PAGE_URLS.donate, true)} />
            </div>,
            <PoweredByBlink />,
        ];
    }
}
